import ApiService from "../service/ApiService";

let moduleApi = {};
let moduleName = "foreigner_qr";

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter,
        message: {
            success: "", //string | null | comment
            error: "",  //string | null | comment
        }
    };
    return ApiService(api);
};


moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id },
        message: {
            success: "", //string | null | comment
            error: "",  //string | null | comment
        }
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: "hidden", //string | null | comment
            error: "hidden",  //string | null | comment
        }
    };
    return ApiService(api);
}

moduleApi.updateVaccinationCertificate = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: "Upload Vaccination certificate successfully", //string | null | comment
            error: "Upload Vaccination certificate failed",  //string | null | comment
        }
    };
    return ApiService(api);
}

moduleApi.updateRemoveVaccinationCertificate = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "Remove Vaccination certificate successfully", //string | null | comment
      error: "Remove Vaccination certificate failed",  //string | null | comment
    }
  };
  return ApiService(api);
};

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm,
        message: {
            success: "hidden", //string | null | comment
            error: "",  //string | null | comment
        }
    };
    return ApiService(api);
}

moduleApi.approveVaccine = (id, data) => {
    let api = {
        module: moduleName,
        type: "approveVaccine",
        value: data,
        params: {
            id
        },
        message: {
            success: "Duyệt thành công", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.rejectVaccine = (id, data) => {
    let api = {
        module: moduleName,
        type: "rejectVaccine",
        value: data,
        params: {
            id
        },
        message: {
            success: "Đã hủy mã", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.approveQR = (id, data) => {
    let api = {
        module: moduleName,
        type: "approveQr",
        value: data,
        params: {
            id
        },
        message: {
            success: "Cấp mã thành công", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.rejectQR = (id, data) => {
    let api = {
        module: moduleName,
        type: "rejectQr",
        value: data,
        params: {
            id
        },
        message: {
            success: "Đã hủy mã", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.approveCheckIn = (id, data, tourist_card) => {
    let api = {
        module: moduleName,
        type: "approveCheckIn",
        value: data,
        params: {
            id,
            tourist_card
        },
        message: {
            success: "Thành công", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.rejectCheckIn = (id, data) => {
    let api = {
        module: moduleName,
        type: "rejectCheckIn",
        value: data,
        params: {
            id
        },
        message: {
            success: "Thành công", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.approveCheckOut = (id, data) => {
    let api = {
        module: moduleName,
        type: "approveCheckOut",
        value: data,
        params: {
            id
        },
        message: {
            success: "Thành công", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.rejectCheckOut = (id, data) => {
    let api = {
        module: moduleName,
        type: "rejectCheckOut",
        value: data,
        params: {
            id
        },
        message: {
            success: "Thành công", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.submitDeclaration = (id, data) => {
    let api = {
        module: moduleName,
        type: "submitDeclaration",
        value: data,
        params: {
            id
        },
        message: {
            success: "hidden", //string | null | comment
            error: "",  //string | null | comment
        }

    };
    return ApiService(api);
};

moduleApi.checkQrCode = (data) => {
  let api = {
    module: moduleName,
    type: "check_qrcode",
    value:{qrCode: data} ,
    message: {
        success: "hidden", //string | null | comment
        error: "hidden",  //string | null | comment
    }
  }
  return ApiService(api);
};

moduleApi.checkExistedQrCode = (data) => {
    let api = {
        module: moduleName,
        type: "views",
        viewAction: "count_existed_qr_code",
        value: data,
        message: {
            success: "hidden", //string | null | comment
            error: "hidden",  //string | null | comment
        }
    }
    return ApiService(api);
}

export default moduleApi;
